import { render, staticRenderFns } from "./MsgConfig.vue?vue&type=template&id=a19da876&scoped=true"
import script from "./MsgConfig.vue?vue&type=script&lang=js"
export * from "./MsgConfig.vue?vue&type=script&lang=js"
import style0 from "./MsgConfig.vue?vue&type=style&index=0&id=a19da876&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19da876",
  null
  
)

export default component.exports